import { IDsData } from '@sky-distribution/adapter-core-pc-rest-interfaces';
import { DigitalGpSubmission } from '@sky-distribution/digital-gp-submission';
import { CoveragesDetails } from '@sky-distribution/gp-onboarding-generic-submission';
import { RateData, Submission } from '@sky-distribution/gp-onboarding-policy-service';
import { AppStateMachineContext } from '../types';
import { billingPeriods } from './billingPeriods';
import { submissionOptions } from './config';
import { coveragesMeta, digitalCoverages } from './coverages';

export const mockedContextConfig: AppStateMachineContext = {
  route: '/',
  productCode: 'hoh',
  language: 'pl',
  salesPortalButtonEnabled: false,
  rateData: {} as RateData,
  submission: {} as Submission,
  digitalSubmission: {} as DigitalGpSubmission,
  ids: {} as IDsData,
  coveragesDetails: {} as CoveragesDetails,
  tenant: '',
  digitalTrackingCodes: {},
  billingPeriods,
  coveragesMeta,
  digitalCoverages,
  submissionOptions,
  consents: {},
  consentDictionary: [],
};
